import React, { Component } from 'react';

export default class Footer extends Component {
    render(){
        return (
            <div className="Footer">
                <div className="flex flex-center">
                    &copy;2018. Ampliee - PÁGINA DE DEMONSTRAÇÃO
                </div>
            </div>
        )
    }
}